import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

// https://github.com/bobwatcherx/vuexPersistenceExample/blob/master/src/stores/mystore.js

var ls = new SecureLS({ isCompression: false });

export default createStore({
  namespace: true,
  state,
  mutations,
  actions,
  getters,
  modules: {},
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
